<template>
    <div v-if="visible" class="popup-overlay">
      <div class="popup-content">
        <van-icon 
          name="cross" 
          class="close-icon" 
          @click="closePopup"
        />
        <div class="popup-body">
          <img 
            class="qr-code" 
            :src="qrCode" 
            alt="QR Code"
          />
          <p class="text" v-html="descriptionLine1"></p>
          <!-- <p class="text">{{ descriptionLine2 }}</p> -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Icon } from "vant";
  export default {
    name: "Popup",
    components: {
      "van-icon": Icon,
    },
    props: {
      visible: {
        type: Boolean,
        default: false, // 控制弹窗显示状态
      },
      qrCode: {
        type: String,
        required: true, // 二维码图片链接
      },
      descriptionLine1: {
        type: String,
        default: "这是第一行介绍文字",
      },
      descriptionLine2: {
        type: String,
        default: "这是第二行介绍文字",
      },
    },
    methods: {
      closePopup() {
        this.$emit("close"); // 触发关闭事件
      },
    },
  };
  </script>
  
  <style scoped>
  .popup-overlay {
    z-index: 22;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .popup-content {
    width: 280px;
    height: 262px;
    background: #fff;
    border-radius: 8px;
    position: relative;
    padding: 24px 0;
    text-align: center;
  }
  
  .close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 20px;
    cursor: pointer;
    color: #999;
  }
  
  .popup-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .qr-code {
    width: 150px;
    height: 150px;
    margin-bottom: 16px;
  }
  
  .text {
    font-size: 16px;
color: #5D5D61;
line-height: 24px;
white-space:pre;
  }
  </style>